const paths = {
  listGroup: '/groups/list',
  editGroup: '/groups/edit'
};

export default paths;
